import { useEffect } from "react";

type PreloadableComponent = {
  preload: () => void | Promise<any>;
};

export function usePreloadComponents(components: PreloadableComponent[]) {
  useEffect(() => {
    const preload = () => {
      components.forEach(Component => {
        if (typeof Component.preload === "function") {
          Component.preload();
        }
      });
    };

    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(preload);
    } else {
      setTimeout(preload, 2000);
    }
  }, [components]);
}
